import React, { Fragment, useContext, useEffect, useState } from "react";
import SearchHeader from "./searchHeader";
import Notification from "./notification";
import UserMenu from "./user-menu";
import Language from "./language";
import {
  AlignLeft,
  Maximize2,
  Bell,
  MessageSquare,
  MoreHorizontal,
} from "react-feather";

//images
import logo from "../../../assets/images/dashboard/logo.png";
import { Autocomplete, TextField } from "@mui/material";
import {
  getAllDistributorMastersCombo,
  getAllDistributorMastersComboByLoginUser,
} from "../../api/service";
import { getAllVendorRegistrationList } from "../../api/ap_services";
import { makeStyles } from "@mui/styles";
import { useCustomerCode } from "../../context/CustomerCodeProvider";
import { useVendorCode } from "../../context/VendorCodeProvider";


const useStyles = makeStyles((theme) => ({
  customAutocompleteInput: {
    "& .MuiInputBase-sizeSmall": {
      height: "40px" /* Adjust the height as needed */,
    },
  },
  autocompleteContainer: {
    display: "flex",
    alignItems: "center",
    marginLeft: "auto", // Move Autocomplete to the right
    marginRight: theme.spacing(2), // Add margin for spacing
  },
}));

const Header = () => {
  const [sidebar, setSidebar] = useState(true);
  const [rightSidebar, setRightSidebar] = useState(true);
  const [navMenus, setNavMenus] = useState(false);
  const classes = useStyles();
  const toggle = () => {
    // setNavMenus((prevState) => ({
    // 	navMenus: !prevState.navMenus,
    // }));
    setNavMenus(!navMenus);
  };

  const [distributorComboData, setDistributorComboData] = useState([]);
  const [vendorComboData, setVendorComboData] = useState([]);
  // const [selectedVendorCode, setSelectedVendorCode] = useState("");
  // const [selectedVendorName, setSelectedVendorName] = useState("");
  const [loading, setLoading] = useState(false);
  const {
    selectedCustomerCode,
    setSelectedCustomerCode,
    selectedCustomerName,
    setSelectedCustomerName,
    setCustomerData,
  } = useCustomerCode();

    const {
    selectedVendorCode,
    setSelectedVendorCode,
    setSelectedVendorName,
    setVendorData,
  } = useVendorCode();

  const isARLocation =
    JSON.parse(sessionStorage.getItem("userData")).locationId === 1;
    
  const isApLocation =
    JSON.parse(sessionStorage.getItem("userData")).locationId === 2;
  useEffect(() => {
    if (isARLocation) {
      setLoading(true);
      if (
        JSON.parse(sessionStorage.getItem("userData")).groupId === 4 || //BSM
        JSON.parse(sessionStorage.getItem("userData")).groupId === 5 || //ASM
        JSON.parse(sessionStorage.getItem("userData")).groupId === 11
      ) {
        getAllDistributorMastersComboByLoginUser().then((res) => {
          setLoading(false);
          setDistributorComboData(res.response.responseObject);
        });
      } else if (JSON.parse(sessionStorage.getItem("userData")).groupId !== 0) {
        getAllDistributorMastersCombo().then((res) => {
          setLoading(false);
          setDistributorComboData(res.response.responseObject);
        });
      }
      if (JSON.parse(sessionStorage.getItem("userData")).groupId === 0) {
        setSelectedCustomerCode(
          JSON.parse(sessionStorage.getItem("userData")).username,
        );
        setSelectedCustomerName(
          JSON.parse(sessionStorage.getItem("userData")).name,
        );
      }
    }else if(isApLocation){
      if (JSON.parse(sessionStorage.getItem("userData")).groupId === 0) {
        setSelectedVendorCode(
          JSON.parse(sessionStorage.getItem("userData")).username,
        );
        setSelectedVendorName(
          JSON.parse(sessionStorage.getItem("userData")).name,
        );
      }
    }
  }, []);

  useEffect(() => {
    if (isApLocation) {
      setLoading(true);
      getAllVendorRegistrationList(0, 9999).then((res) => {
        setLoading(false);
        const list = res?.response?.responseObject ?? [];
        const withVendorCode = Array.isArray(list)
          ? list.filter(
              (item) =>
                (item.vendorCode ?? item.vendor_code ?? "").toString().trim() !==
                "",
            )
          : [];
        setVendorComboData(withVendorCode);
      });
    }
  }, [isApLocation]);

  /* useEffect(() => {
    console.log(selectedCustomerCode, "selectedCustomerCode");
  }, [selectedCustomerCode]); */

  const showRightSidebar = () => {
    if (rightSidebar) {
      setRightSidebar(false);
      document.querySelector(".right-sidebar").classList.add("show");
    } else {
      setRightSidebar(true);
      document.querySelector(".right-sidebar").classList.remove("show");
    }
  };
  const goFull = () => {
    if (
      (document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)
    ) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(
          Element.ALLOW_KEYBOARD_INPUT,
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  };
  const openCloseSidebar = () => {
    if (sidebar) {
      setSidebar(false);
      document.querySelector(".page-main-header").classList.add("open");
      document.querySelector(".page-sidebar").classList.add("open");
      document.querySelector(".footer").classList.add("open");
    } else {
      setSidebar(true);
      document.querySelector(".page-main-header").classList.remove("open");
      document.querySelector(".page-sidebar").classList.remove("open");
      document.querySelector(".footer").classList.remove("open");
    }
  };
  const isDistributorUser =
    JSON.parse(sessionStorage.getItem("userData")).groupId === 0 && JSON.parse(sessionStorage.getItem("userData")).locationId === 1;

    const isVendorUser =
    JSON.parse(sessionStorage.getItem("userData")).groupId === 0 && JSON.parse(sessionStorage.getItem("userData")).locationId === 2;

  const isViewTDSUser =
    JSON.parse(sessionStorage.getItem("userData")).groupId === 12;

  return (
    <Fragment>
      {/* open */}
      <div className="page-main-header ">
        <div className="main-header-right row">
          <div className="main-header-left d-lg-none col-auto">
            <div className="logo-wrapper">
              <a href="#">
                <img className="blur-up lazyloaded" src={logo} alt="" />
              </a>
            </div>
          </div>
          <div className="mobile-sidebar col-auto p-0">
            <div className="media-body text-end switch-sm">
              <label className="switch">
                <a href="#javaScript" onClick={openCloseSidebar}>
                  <AlignLeft />
                </a>
              </label>
            </div>
          </div>
          <div className="nav-right col" style={{ display: "contents" }}>
            <div className={classes.autocompleteContainer}>
              {isARLocation && !isDistributorUser && !isViewTDSUser && (
                <Autocomplete
                  className={classes.customAutocompleteInput}
                  options={distributorComboData}
                  sx={{ width: 300 }}
                  getOptionLabel={(option) =>
                    option.sapPartyCode + " - " + option.subParty
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Customer Code"
                      variant="outlined"
                    />
                  )}
                  size={"small"}
                  onChange={(event, value) => {
                    if (value) {
                      setSelectedCustomerCode(value.sapPartyCode);
                      setSelectedCustomerName(value.subParty);
                      setCustomerData(value);
                    } else {
                      // If no value is selected, clear the searchData.searchCustomerCode
                      setSelectedCustomerCode("");
                      setSelectedCustomerName("");
                      setCustomerData(null);
                    }
                  }}
                />
              )}
              {isApLocation && !isVendorUser && (
                <Autocomplete
                  className={classes.customAutocompleteInput}
                  options={vendorComboData}
                  sx={{ width: 300 }}
                  getOptionLabel={(option) => {
                    const code = option.vendorCode ?? option.vendor_code ?? "";
                    const name =
                      option.companyName ?? option.company_name ?? "";
                    return name ? `${code} - ${name}` : code;
                  }}
                  value={
                    selectedVendorCode
                      ? vendorComboData.find(
                          (v) =>
                            (v.vendorCode ?? v.vendor_code) ===
                            selectedVendorCode,
                        ) ?? null
                      : null
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Vendor Code"
                      variant="outlined"
                    />
                  )}
                  size={"small"}
                  onChange={(event, value) => {
                    if (value) {
                      setSelectedVendorCode(
                        value.vendorCode ?? value.vendor_code ?? "",
                      );
                      setSelectedVendorName(
                        value.companyName ?? value.company_name ?? "",
                      );
                      setVendorData(value);
                    } else {
                      setSelectedVendorCode("");
                      setSelectedVendorName("");
                      setVendorData(null);
                    }
                  }}
                />
              )}
            </div>

            <ul className={"nav-menus " + (navMenus ? "open" : "")}>
              {/* <li>
								<SearchHeader />
							</li>
							<li>
								<a onClick={goFull} className="text-dark" href="#javaScript">
									<Maximize2 />
								</a>
							</li>
							<li className="onhover-dropdown">
								<a className="txt-dark" href="#javaScript">
									<h6>EN</h6>
								</a>
								<Language />
							</li> */}

              {/* <li className="onhover-dropdown">
								<Bell />
								<span className="badge rounded-pill badge-primary pull-right notification-badge">
									3
								</span>
								<span className="dot"></span>
								<Notification />
							</li>
							<li>
								<a href="#javaScript" onClick={showRightSidebar}>
									<MessageSquare />
									<span className="dot"></span>
								</a>
							</li> */}
              <UserMenu />
            </ul>
            <div
              className="d-lg-none mobile-toggle pull-right"
              onClick={() => toggle()}
            >
              <MoreHorizontal />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Header;
